import RoundedModal from './RoundedModal';

export default RoundedModal;
